import './AddNewElementButtonModal.less'

import { ButtonLight } from 'front-end/src/components'
import React, { useState } from 'react'

import { t, Trans } from '@lingui/macro'

import { Modal } from '../../../components/common/modal/Modal'
import { ChooseElement } from '../../topic-detail-page/components/choose-element/ChooseElement'

export const AddNewElementButtonModal = () => {
  const [modalVisible, setModalVisible] = useState(false)

  return (
    <>
      <li className="page-thumbnail page-create">
        <div className="page-thumbnail-switch">
          <div
            onClick={() => setModalVisible(true)}
            className="page-thumbnail-item page-thumbnail-item__new"
          >
            <span className="icon icon-plus"></span>

            <div className="label">
              <Trans>New</Trans>
            </div>
          </div>
        </div>
      </li>

      <Modal
        header={t`Add another element`}
        show={modalVisible}
        size="WIDE"
        className="AddNewElement"
        controls={
          <ButtonLight onClick={() => setModalVisible(false)}>
            <Trans>Cancel</Trans>
          </ButtonLight>
        }
      >
        <ChooseElement isModalMode onChosen={() => setModalVisible(false)} />
      </Modal>
    </>
  )
}
